import Vue from 'vue'
import Vuex from 'vuex'
import { api } from '@/plugins/api'
import Traduction from './modules/traduction'
Vue.use(Vuex)

/* eslint-disable */

const state = {
	MarchesApplications: [],
	SecteursActivites: [],
	Pays: [],
	CasUtilisation: {},
	CasUtilisations: [],
	selectedCasUtilisation: {},
	selectedMarcheApplication: [],
	selectedSecteurActivite: [],
	selectedPays: [],
	selectedLocalisation: '',
}

const getters = {
	GET_CAS_UTILISATION_UNIQUE(state) {
		return state.CasUtilisation;
	},

	GET_CAS_UTILISATION(state) {
		return state.CasUtilisations.filter(c => c.Selection);
	},
	GET_CAS_UTILISATION_SANS_DELEGUATION(state) {
		return state.CasUtilisations.filter(c => c.Selection && c.Deleguation != true);
	},
	GET_PAYS(state) {
		return state.Pays;
	},
}

const mutations = {
	SET_PAYS(state, Pays) {
		state.Pays = Pays
	},
	SET_MARCHES_APPLICATIONS(state, MarchesApplications) {
		state.MarchesApplications = MarchesApplications
	},
	SET_SECTEURS_ACTIVITES(state, SecteursActivites) {
		state.SecteursActivites = SecteursActivites
	},
	SET_CAS_UTILISATION(state, CasUtilisations) {
		state.CasUtilisations = CasUtilisations
	},
	SET_CAS_UTILISATION_UNIQUE(state, CasUtilisation) {
		state.CasUtilisation = CasUtilisation
	},
	SELECTION_CAS_UTILISATION(state, { cas, selection }) {
		state.CasUtilisations.find(c => c.Id == cas.Id).Selection = selection
	}
}

const actions = {
	ChargerCasUtilisationById(store, id) {
		return api.get('casutilisation/' + id + '/fr')
	},
	async ChargerPays(store, lang) {
		const response = await api.get('filtres/pays/' + lang)
		store.commit('SET_PAYS', response.data)
	},
	async ChargerMarcheApplication(store, lang) {
		const response = await api.get('filtres/marcheapplication/' + lang)
		store.commit('SET_MARCHES_APPLICATIONS', response.data)
	},
	async ChargerSecteurActivite(store, lang) {
		const response = await api.get('filtres/secteuractivite/' + lang)
		store.commit('SET_SECTEURS_ACTIVITES', response.data)
	},
	async ChargerCasUtilisation(store, lang) {
		const response = await api.get('casutilisation/all/' + lang)
		store.commit('SET_CAS_UTILISATION', response.data)
	},
	ChargerCasUtilisationFiltrer (store, { selectedMarchesApplications, selectedSecteursActivites, selectedPays, lang }) {
		api.post('casutilisation/filtrer', {
			IdsMarcheApplication: selectedMarchesApplications,
			IdsSecteurActivite: selectedSecteursActivites,
			Pays: selectedPays,
			lang: lang,
		}).
			then(function (response) {
				store.commit('SET_CAS_UTILISATION', response.data)
			}).catch(function (err) {
				// eslint-disable-next-line no-console
				console.log(err)
			})
	},
	Filtrer(store, { selectedMarchesApplications, selectedSecteursActivites, selectedPays, localisation }) {
		this.selectedMarcheApplication = selectedMarchesApplications
		this.selectedSecteurActivite = selectedSecteursActivites
		this.selectedLocalisation = localisation
		this.selectedPays = selectedPays
		if (selectedMarchesApplications.length == 0 && selectedSecteursActivites.length == 0 && selectedPays.length == 0 && !localisation) {
			state.CasUtilisations.forEach(function (cas) {
				store.commit('SELECTION_CAS_UTILISATION', { cas: cas, selection: true });
			})
		} else {
			state.CasUtilisations.forEach(function (cas) {
				var matchMarche = false
				var matchSecteur = false
				var matchLocation = false
				var matchDeleguation = false
				var matchPays = false
				let selection = true

				if (localisation) {
					var normalizedLocation = localisation.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
					matchLocation = cas.AdresseCasUtilisation.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(normalizedLocation)
					if (!matchLocation) {
						matchLocation = cas.EntrepriseDeveloppeuse.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(normalizedLocation)
					}
					if (!matchLocation) {
						matchLocation = cas.EntrepriseUtilisatrice.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(normalizedLocation)
					}
					if (!matchLocation) {
						matchLocation = cas.Titre.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(normalizedLocation)
					}
					if (!matchLocation) {
						matchLocation = cas.EntrepriseDeveloppeuse2.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(normalizedLocation)
					}
					if (!matchLocation) {
						matchLocation = cas.EntrepriseDeveloppeuse3.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(normalizedLocation)
					}
					if (!matchLocation && cas.DescriptionProjet != null && cas.DescriptionProjet != "") {
						matchLocation = cas.DescriptionProjet.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "").includes(normalizedLocation)
					}
				}

				if (selectedMarchesApplications.length > 0) {
					cas.ListeIdMarcheApplication.forEach(function (el) {
						if (selectedMarchesApplications.find(function (x) {
							return x.id == el
						})/* && (!selection)*/) {
							matchMarche = true
						}
					})
				}
				if (selectedSecteursActivites.length > 0) {
					cas.ListeIdSecteurActivite.forEach(function (el) {
						if (selectedSecteursActivites.find(function (x) {
							return x.id == el
						})/* && (!selection)*/) {
							matchSecteur = true
						}
					})
				}
				if (selectedPays.length > 0) {

					if (selectedPays.find(function (x) {
						if (cas.Pays != null) {
							return cas.Pays.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "") == x.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, "")
						} else {
							return false
						}
						
					})/* && (!selection)*/) {
						matchPays = true
					}
				}
				if (cas.Deleguation) {
					matchDeleguation = true
				}

				if (!matchDeleguation) {
					if (selectedMarchesApplications.length > 0) {
						selection = selection && matchMarche
					}
					if (selectedSecteursActivites.length > 0) {
						selection = selection && matchSecteur
					}
					if (selectedPays.length > 0) {
						selection = selection && matchPays
					}
					if (localisation) {
						selection = selection && matchLocation
					}
				} else {
					selection = selection && matchDeleguation
				}

				store.commit('SELECTION_CAS_UTILISATION', { cas: cas, selection: selection });
			})
		}
	},
	FiltrerParLocation(store, { locationRect }) {
		if (!this.selectedMarcheApplication && !this.selectedSecteurActivite && !this.selectedPays && !this.selectedLocalisation) {
			let selection = true
			if (state.CasUtilisations) {
				state.CasUtilisations.forEach(function (cas) {
					if (cas.Geolocalisation) {
						if (locationRect.contains(new Microsoft.Maps.Location(cas.Geolocalisation.Latitude, cas.Geolocalisation.Longitude))) {
							selection = true
						} else {
							selection = false
						}
						store.commit('SELECTION_CAS_UTILISATION', { cas: cas, selection: selection });
					}
				})
			}
		}
	}
}

export default new Vuex.Store({
	modules: {
		Traduction
	},
	state: state,
	mutations: mutations,
	getters: getters,
	actions: actions
})